module.exports = __webpack_public_path__ + "img/CRT_Sword-005.4ef312c8.png";